import Phase from '../config/env.mjs';
export const DEFAULT_URL = {
    STOP: '/stop',
    ERROR: '/error',
};
export function getPayUrl(phase) {
    switch (phase) {
        case Phase.local:
        case Phase.dev:
            return {
                mobile: 'https://alpha-m.pay.naver.com',
                pc: 'https://alpha-pay.naver.com',
            };
        case Phase.test:
            return {
                mobile: 'https://test-m.pay.naver.com',
                pc: 'https://test-pay.naver.com',
            };
        case Phase.stage:
            return {
                mobile: 'https://beta-m.pay.naver.com',
                pc: 'https://beta-pay.naver.com',
            };
        case Phase.real:
        default:
            return {
                mobile: 'https://m.pay.naver.com',
                pc: 'https://pay.naver.com',
            };
    }
}
export function getHeaderField(field) {
    return Array.isArray(field) ? field[0] : field;
}
